
import tables_title_en from './tables_title/tables_title_en'
import elementEnLocale from 'element-ui/lib/locale/lang/en'

import user_management_en from './user_management/user_management_en'
import role_management_en from './role_management/role_management_en'
import dept_management_en from './dept_management/dept_management_en'
import posts_management_en from './posts_management/posts_management_en'
import dict_management_en from './dict_management/dict_management_en'
import menu_management_en from './menu_management/menu_management_en'
import notice_management_en from './notice_management/notice_management_en'
import tenant_management_en from './tenant_management/tenant_management_en'

const en = {
  global:{
    home:'home',
    system:'system',
    users:'users',
    roles:'roles',
    depts:'depts',
    posts:'posts',
    dict_type:'dict type',
    menus:'menus',
    login_log:'login log',
    business_log:'business log',
    messages:'messages',
    tenants:'tenants',
    search:'search',
    add:'add',
    back:'back',
    export:'export',
    expand_all:'expand all',
    clear_log:'clear log',
    modify:'edit',
    delete:'delete',
    details:'details',
    operation:'operation',
    submit:'submit',
    cancel:'cancel',
    logout:'logout',
    look: 'look',
    confirm:'confirm',
    change_password:'change password',
    old_password:'old password',
    new_password:'new password',
    empty_old_pwd:'Please enter your old password',
    empty_new_pwd:'Please enter your new password',
    modified_success:'Modified successfully',
    added_success:'Added successfully',
    del_success:'Delete succeeded',
    select_export:'Please select the data to export',
    table_data_title:'Data table',
    tips:'Tips',
    empty_sort:'Please enter sorting',
    dev_tools:'develope',

    questionnaire:'questionnaire survey',
    create_scale:'Create scale',
    scale_manage: 'Inventory management',
    business_menu: 'Business menu',
    health_assessment_manage: 'Health assessment management',
    questionnaire_survey_manage: 'Questionnaire Management',
    model_manage: 'model management',
    look_issue_msg: 'Viewing Publication Information',
    edit_relevance_scale: 'Edit correlation scale',
    look_relevance_scale: 'Viewing the Association Scale',
    patient_manage: 'patient management',
    look_relevance_model: 'Viewing the association Model',
    index_manage: 'index management',
    edit: 'edit',
    reset: 'reset',
    refresh: 'refresh',
    edit_index: 'Edit the indicators',
    go_back: 'return',
    look_model_fill_in_ed: 'View the filled model',
    look_worked_scale: 'Check the completed form',
    look_report:'Viewing Reports',
    look_data:'Viewing data',
    evaluated_report:'Evaluated report',
    look_index_report: 'Viewing Indicator Reports',
    project_manage: 'Project Management',
    edit_relevance_model: 'Edit correlation model',
    look_relevance_model: 'Viewing the association Model',
    set_gross_score_index: 'Set the total score index',
    label_manage: 'label management',
    export_data: 'export data',
    statistic_analysis: 'statistic analysis',
    home_page: 'home page',
    register:'register',
    create_index: 'Create index',
    visual_create_index: 'Create metrics visually',
    write_astrict: 'Fill in the limit',
    verify_index_var: 'Check index variable',
    set_evaluate_index: 'Setting evaluation indicators',
    update_index_var_topic_title: 'Updated indicator variable title',
    evaluator_manage:'Evaluator manage',
    view_document:'View document',
    import_scale:'Import scale',
    export_scale:'Export scale',
    questionnaire_manage:'Questionnaire manage',
    questionnaire_name:'Questionnaire name',
    issue:'Issue',
    answer:'Answer',
    export_file:'Export file',
    copy:'Copy',
    selfcheck_scale_manage:'Selfcheck scale manage',
    assess_results_reporting:'Assess results reporting',
    questionnaire_attribute: 'Auestionnaire attribute',
    label_type_manage:'Label type manage',
    add_child_type: "Add child  type",
    data_analysis:'Data analysis',
    role_scale:'role scale',
    assignment: 'assignment'

  },
  tables_title:tables_title_en,
  ...elementEnLocale,
  user_management:user_management_en,
  role_management:role_management_en,
  dept_management:dept_management_en,
  posts_management:posts_management_en,
  dict_management:dict_management_en,
  menu_management:menu_management_en,
  notice_management:notice_management_en,
  tenant_management:tenant_management_en
}


export default en



// WEBPACK FOOTER //
// ./src/common/lang/en.js